<style lang="less" scoped>	
	.wsplus-body {
	}
</style>
<template>
	<section class="wsplus-body" :class="leftSideOpen ? 'left-side-collapsed' : ''">
		<ws-header></ws-header>
		<ws-content></ws-content>
		<ws-tip></ws-tip>
	</section>
</template>
<script>
    import $ from 'jquery'
    import nicescroll from 'jquery.nicescroll'
	import wsHeader from './header.vue'
	import wsContent from './content.vue'
	import wsTip from './tip.vue'
    export default {
    	components: {
			wsHeader,
		    wsContent,
			wsTip
		},
        data() {
        	return {
        		projectName: '测试系统'
        	}
        },
        computed: {
        	leftSideOpen() { //左边关闭状态计算属性
        		const isOpen =  this.$store.getters.framework_leftSideOpenStatus;
        		return isOpen;
        	}
        },
        mounted() {
            this.$nextTick(function() {
                $(".left-side").niceScroll({
                    cursorwidth: "2px",
                    horizrailenabled: false
                });
                // $("html").niceScroll({
                //     cursorwidth: "5px",
                //     scrollspeed: 30,
                //     horizrailenabled: false
                // });                  
            });         
        }
    }
</script>


// WEBPACK FOOTER //
// main.vue?7445eb28